import React from "react"

const SimpleStack = ({ previewData, headerColor, textColor }) => {
  return (
    <div
      style={{
        paddingTop: "5px",
        flexWrap: "wrap",
        flexDirection: "column",
        justifyContent: "center",
        display: "flex",
        alignContent: "center",
      }}
    >
      {previewData.map((x, index) => (
        <span
          key={index}
          style={{
            color: textColor,
            fontSize: "1em",
            padding: "5px",
            width: "85%",
            height: "35px",
            borderRadius: "5px",
            textAlign: "center",
            backgroundColor: headerColor,
            marginTop: "10px",
          }}
        >
          {x?.name}
        </span>
      ))}
    </div>
  )
}

export default SimpleStack
